export default "__VITE_ASSET__npUV9uN4__"